export default __webpack_public_path__ + "static/assets/9380de8daef16e0dc6b630e072c81cb5.png";